import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import {
  getPaintCoating,
  getEquipmentMachinery,
  getStructureAndHull,
  getStores,
  getShipManagementDetail,
} from "../Actions/ShipManagementAPI";
import PaintCoating from "./PaintCoating";
import {
  deleteShipManagementDetails,
  postInventoryDetails,
  getShipManagementList,
} from "../Actions/ShipManagementAPI";
import axios from "axios";
import API from "../helpers/api";
import Moment from "moment";
import { toast } from "react-toastify";
import Role from "../helpers/role";

let user = JSON.parse(localStorage.getItem("currentUser"));
let userRole = localStorage.getItem("UserRoles");
let searchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 25,
};
class ShipManagementDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
  }
  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getShipManagementDetail(id));
    dispatch(getPaintCoating(id));
    dispatch(getEquipmentMachinery(id));
    dispatch(getStructureAndHull(id));
    dispatch(getStores(id));
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { match, dispatch } = nextProps;
    const { params } = match;
    const { id } = params;
    let updatedState = {};
    if (id !== prevState.id) {
      prevState.id = id;
      updatedState.id = id;
      //    dispatch(getShipManagementDetails(id));
      //    dispatch(getShipEquipmentDetails(id));
    }

    return updatedState;
  }
  hideSidePanel = () => {
    this.setState({ showSidePane: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Ship");
  };
  render() {
    const {
      ShipDetails,
      PaintCoating,
      EquipmentMachinery,
      StructureAndHull,
      Store,
    } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.hideSidePanel()}
                  >
                    &larr; Return
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        Ship Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-12 mb-2">
                          <span>
                            <strong>Ship Name : </strong>
                            {ShipDetails ? ShipDetails.shipName : ""}{" "}
                          </span>
                        </div>
                        {/* <div className="col-sm-6 mb-2">
                                                    <span><strong>Client Name : </strong>{ShipDetails ? ShipDetails.clientName : ""} </span>
                                                </div> */}
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>IMO No : </strong>
                            {ShipDetails ? ShipDetails.imoNo : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Flag : </strong>
                            {ShipDetails ? ShipDetails.flag : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Class : </strong>
                            {ShipDetails ? ShipDetails.class : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Enrollment Date : </strong>
                            {ShipDetails && ShipDetails.dateOfBuild
                              ? Moment(
                                new Date(Date.parse(ShipDetails.dateOfBuild))
                              ).format("YYYY-MM-DD")
                              : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>PO Pull Date : </strong>
                            {ShipDetails && ShipDetails.pullDate
                              ? Moment(
                                new Date(Date.parse(ShipDetails.pullDate))
                              ).format("YYYY-MM-DD")
                              : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>PO First Pull Date : </strong>
                            {ShipDetails && ShipDetails.poFirstPulledDate
                              ? Moment(
                                new Date(
                                  Date.parse(ShipDetails.poFirstPulledDate)
                                )
                              ).format("YYYY-MM-DD")
                              : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        Ship Contact Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Ship Email : </strong>
                            {ShipDetails ? ShipDetails.shipEmail : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Ship Contact Number 1 : </strong>
                            {ShipDetails ? ShipDetails.phone1 : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Ship Contact Number 2 : </strong>
                            {ShipDetails ? ShipDetails.phone2 : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>Invoice Forwarding Email : </strong>
                            {ShipDetails
                              ? ShipDetails.invoiceForwardingEmail
                              : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>Vessel Group Email : </strong>
                            {ShipDetails
                              ? ShipDetails.vesselGroupEmail
                              : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>Designated Person : </strong>
                            {ShipDetails
                              ? ShipDetails.designatedPerson
                              : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        Company Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Company Name : </strong>
                            {ShipDetails ? ShipDetails.companyName : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Fleet Manager : </strong>
                            {ShipDetails ? ShipDetails.fleetManager : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>Technical Superintendent : </strong>
                            {ShipDetails
                              ? ShipDetails.technicalSuperintendent
                              : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>Technical Executive : </strong>
                            {ShipDetails
                              ? ShipDetails.technicalExecutive
                              : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        {" "}
                        Paint & Coating Systems
                      </h5>
                    </div>
                    <div
                      className="history-box pt-3 search-filter-box"
                      style={{ maxHeight: "360px" }}
                    >
                      {PaintCoating
                        ? PaintCoating.map((item) => (
                          <div
                            className="card MM-card-content click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Name : </strong>
                                      {item.name}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Application : </strong>
                                      {item.application}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Location : </strong>
                                      {item.location}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Materials : </strong>
                                      {item.material}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Quantity : </strong>
                                      {item.quantity}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Unit : </strong>
                                      {item.unit}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>PCHM / CHM : </strong>
                                      {item.pchmchm}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-12 py-1">
                                    <span>
                                      <strong>Remarks : </strong>
                                      {item.remarks}{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        {" "}
                        Equipment & Machinery{" "}
                      </h5>
                    </div>
                    <div
                      className="history-box pt-3 search-filter-box"
                      style={{ maxHeight: "360px" }}
                    >
                      {EquipmentMachinery
                        ? EquipmentMachinery.map((item) => (
                          <div
                            className="card MM-card-content click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Name : </strong>
                                      {item.name}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Material : </strong>
                                      {item.material}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Location : </strong>
                                      {item.location}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Parts : </strong>
                                      {item.parts}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Quantity : </strong>
                                      {item.quantity}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Unit : </strong>
                                      {item.unit}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>PCHM / CHM : </strong>
                                      {item.pchmchm}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-12 py-1">
                                    <span>
                                      <strong>Remarks : </strong>
                                      {item.remarks}{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        {" "}
                        Structure & Hull{" "}
                      </h5>
                    </div>
                    <div
                      className="history-box pt-3 search-filter-box"
                      style={{ maxHeight: "360px" }}
                    >
                      {StructureAndHull
                        ? StructureAndHull.map((item) => (
                          <div
                            className="card MM-card-content click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Name : </strong>
                                      {item.name}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Material : </strong>
                                      {item.material}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Location : </strong>
                                      {item.location}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Parts : </strong>
                                      {item.parts}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Quantity : </strong>
                                      {item.quantity}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Unit : </strong>
                                      {item.unit}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>PCHM / CHM : </strong>
                                      {item.pchmchm}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-12 py-1">
                                    <span>
                                      <strong>Remarks : </strong>
                                      {item.remarks}{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        {" "}
                        Stores{" "}
                      </h5>
                    </div>
                    <div
                      className="history-box pt-3 search-filter-box"
                      style={{ maxHeight: "360px" }}
                    >
                      {Store
                        ? Store.map((item) => (
                          <div
                            className="card MM-card-content click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Name : </strong>
                                      {item.name}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Material : </strong>
                                      {item.material}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Location : </strong>
                                      {item.location}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Parts : </strong>
                                      {item.parts}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Quantity : </strong>
                                      {item.quantity}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>Unit : </strong>
                                      {item.unit}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-6 py-1">
                                    <span>
                                      <strong>PCHM / CHM : </strong>
                                      {item.pchmchm}{" "}
                                    </span>
                                  </div>
                                  <div className="col-sm-12 py-1">
                                    <span>
                                      <strong>Remarks : </strong>
                                      {item.remarks}{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.EditShipDetails()}
                        >
                          Edit
                        </button>
                        {userRole == Role.mmpladmin ? <>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.DeletePopup()}
                          >
                            {" "}
                            Delete{" "}
                          </button> </> : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  EditShipDetails() {
    const { match, dispatch, ShipDetails } = this.props;
    const { params } = match;
    const { id } = params;
    this.props.history.push(`/Home/Management/ShipEdit/${id}`);
    this.props.dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "CompanayName", data: ShipDetails.companyName });
    dispatch({ type: "InventoryUploadSuccess", data: null });
  }

  DeletePopup() {
    confirmAlert({
      message: 'Are you sure want to delete ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.DeleteShipDetails()
          }
        },
        {
          label: 'No',
          onClick: () => { }
        }
      ]
    });
  }

  DeleteShipDetails() {
    const {
      ShipDetails,
      PaintCoating,
      EquipmentMachinery,
      StructureAndHull,
      Store,
      pagesearch,
      match,
      dispatch,
    } = this.props;
    const { params } = match;
    const { id } = params;
    let invent1 = PaintCoating.map((r1) => {
      r1.isDeleted = true;
      return r1;
    });
    let invent2 = EquipmentMachinery.map((r2) => {
      r2.isDeleted = true;
      return r2;
    });
    let invent3 = StructureAndHull.map((r3) => {
      r3.isDeleted = true;
      return r3;
    });
    let invent4 = Store.map((r4) => {
      r4.isDeleted = true;
      return r4;
    });
    let ship = {
      shipId: parseInt(id),
      shipName: ShipDetails.shipName,
      clientName: ShipDetails.companyName,
      imoNo: ShipDetails.imoNo,
      flagName: ShipDetails.flag,
      className: ShipDetails.class,
      shipEmail: ShipDetails.shipEmail,
      vesselGroupEmail: ShipDetails.vesselGroupEmail,
      invoiceForwardingEmail: ShipDetails.invoiceForwardingEmail,
      phone1: ShipDetails.phone1,
      phone2: ShipDetails.phone2,
      hkcIssuedBy: ShipDetails.hkcIssuedBy,
      hkcIssuedDate: ShipDetails.hkcIssuedDate ? ShipDetails.hkcIssuedDate : "",
      eussrAttachmentName: ShipDetails.eussrAttachmentName,
      eussrAttachmentGuid: ShipDetails.eussrAttachmentGuid,
      hkcAttachmentName: ShipDetails.hkcAttachmentName,
      hkcAttachmentGuid: ShipDetails.hkcAttachmentGuid,
      hkcExpiryDate: ShipDetails.hkcExpiryDate ? ShipDetails.hkcExpiryDate : "",
      euSSRIssuedBy: ShipDetails.euSSRIssuedBy,
      euSSRIssuedDate: ShipDetails.euSSRIssuedDate
        ? ShipDetails.euSSRIssuedDate
        : "",
      euSSRExpiryDate: ShipDetails.euSSRExpiryDate
        ? ShipDetails.euSSRExpiryDate
        : "",
      isDeleted: true,
      modifiedBy: user.email || "",
      shipUsers: [
        {
          userName: ShipDetails.fleetManager,
          role: "fleetmanager",
        },
        {
          userName: ShipDetails.technicalSuperintendent,
          role: "superintendent",
        },
        {
          userName: ShipDetails.technicalExecutive,
          role: "technicalexecutive",
        },
      ],
    };
    let inventory = {
      shipId: parseInt(id),
      paintAndCoating: invent1,
      equipmentAndMachinery: invent2,
      structureAndHull: invent3,
      store: invent4,
    };
    let url = `${API.postShip}`;
    axios
      .put(url, ship, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        dispatch(postInventoryDetails(inventory));
        toast.success("Deleted Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.hideSidePanel();
        dispatch(getShipManagementList(searchData));
        dispatch({
          type: "deleteShipDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "deleteShipDetailsFailure",
          error: "ERROR",
        });
      });

    //  this.props.dispatch(deleteShipManagementDetails(ship, pagesearch));
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ShowMISidePan: state.SidePanReducer.ShowMISidePan || false,
    ShowRDSidePan: state.SidePanReducer.ShowRDSidePan || false,
    ShowEURegSidePan: state.SidePanReducer.ShowEURegSidePan || false,
    ShipDetails: state.MasterScreenReducer.ShipDetails,
    ShipEquipment: state.MasterScreenReducer.ShipEquipmentDetails,
    PaintCoating: state.MMPLDashboardReducer.PaintCoating,
    EquipmentMachinery: state.MMPLDashboardReducer.EquipmentMachinery,
    StructureAndHull: state.MMPLDashboardReducer.StructureAndHull,
    Store: state.MMPLDashboardReducer.Store,
    pagesearch: state.MasterScreenReducer.pagesearch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipManagementDetail)
);
